import { render, staticRenderFns } from "./PermGenBar.vue?vue&type=template&id=dee6db80&"
import script from "./PermGenBar.vue?vue&type=script&lang=js&"
export * from "./PermGenBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports